@if (linkedEquipment()) {
  <div class="mb-4 text-sm" role="status">Verknüpfte Komponente
    <a class="ml-2 underline" [routerLink]="[]" [queryParams]="{}">Alle Komponenten anzeigen</a>
  </div>
}
<div class="space-y-6">
  <!-- Storages Table -->
  <app-data-table
    [data]="visibleEquipment()"
    [columns]="columns"
    [rowActions]="actions"
    [isLoading]="isLoading()"
    [searchableFields]="['name', 'size', 'cost']"
    addNewLabel="Speicher hinzufügen"
    [showAddButton]="currentOrgStore.can('organization', 'createequipment')"
    emptyStateTitle="Keine Speicher gefunden"
    emptyStateDescription="Fügen Sie Speicher hinzu oder synchronisieren Sie globale Speicher."
    (addNew)="addStorage()"
  />

  <!-- Create Storage Dialog -->
  <app-create-storage-dialog
    #createDialog
    [editStorage]="editingStorage()"
    (submitted)="syncStorages()"
  />

  <!-- Templates -->
  <ng-template #storageTpl let-storage>
    <div>
      <div class="text-sm">{{ storage.name }}</div>
      <div class="text-xs text-muted-foreground">
        {{ storage.manufacturer }}
      </div>
    </div>
  </ng-template>

  <ng-template #capacityTpl let-storage>
    <div class="text-right text-sm tabular-nums">{{ storage.size | number: "1.1-1" }} kWh</div>
  </ng-template>

  <ng-template #priceTpl let-storage>
    <div class="text-right text-sm tabular-nums">{{ storage.cost | number: "1.2-2" }} €</div>
  </ng-template>
</div>
